module.exports = __webpack_public_path__ + "static/media/ELABORADO_COLOR.106ff065.svg";